$(document).ready(function(){

    if($('.category-nav').length) {

        var $window        = $(window);
        var $body          = $('body');
        var $catnav        = $('.category-nav');
        var navHeight      = $catnav.outerHeight();
        var $parent        = $('.programs');
        var $categories    = $('.category');
        var parentHeight   = $parent.outerHeight() - navHeight;
        var stickPoint     = $catnav.offset().top - 166;
        var $navLink       = $('.category-nav li');
        var $section       = $('section[data-catnav]');

    

        var leftReset = function() {
            var currentLeftOffset = $parent.offset().left;
            parentHeight   = $parent.outerHeight();
            $catnav.css('left', currentLeftOffset)
        }

        var stickySwitch = function() {
            var currentPosition     = $window.scrollTop();
            var currentLeftOffset   = $parent.offset().left;

            if (currentPosition >= stickPoint && currentPosition <= (stickPoint + parentHeight) - (navHeight + 70)) {
                if ($window.width() >= 1030) {
                    $parent.addClass('sticky');
                    $parent.removeClass('bottom-sticky');
                    leftReset();
                }
            } else if (currentPosition >= stickPoint && currentPosition >= (stickPoint + parentHeight) - (navHeight + 70)) {
                if ($window.width() >= 1030) {
                    $parent.removeClass('sticky');
                    $parent.addClass('bottom-sticky');
                    leftReset();
                }
            } else {
                if ($window.width() >= 1030) {
                    $parent.removeClass('sticky');
                    $parent.removeClass('bottom-sticky');
                    leftReset();
                }
            }
        }

        stickySwitch();
        $window.scroll(stickySwitch);
        $window.resize(leftReset);

        $navLink.on('click', function(){
            var dataNavLink = $(this).attr('data-catnav');

            $categories.each(function(){
                var dataNavSection  = $(this).attr('data-catnav');
                var scrollPoint     = $(this).offset().top;

                if (dataNavSection == dataNavLink) {
                    $('html, body').animate({
                        scrollTop: scrollPoint - 150
                    });
                }
            });
        });

        $window.scroll(function(){
            var currentPosition = $window.scrollTop();

            $navLink.each(function(){
                var dataNav             = $(this).attr('data-catnav');
                var associatedElement   = $('.category[data-catnav="' + dataNav + '"]');

                if (associatedElement.offset().top <= (currentPosition + 200) && associatedElement.offset().top + associatedElement.height() > currentPosition) {
                    $navLink.removeClass('active');
                    $(this).addClass('active');
                } else {
                    $(this).removeClass('active');
                }
            });
        });

    } 
});